<template>
  <li class="mb-md">
    <a :href="product.url" class="flex items-center c-black">
      <figure v-show="!!product.image">
        <img :src="product.image" :alt="product.title" width="140" height="140" />
      </figure>
      <div class="p-md">
        <h5 v-show="!!product.title" class="mb-sm text-base fw-strong">
          {{ product.title }}
        </h5>
        <p v-show="!!product.description" class="text-sm">
          {{ product.description }}
        </p>
        <div v-if="product.finish" class="mt-sm flex items-center">
          <div class="swatch" :data-finish="product.finish" />
          <p class="m-0 ml-sm text-sm">{{ product.finish }}</p>
        </div>
        <p v-show="product.product_line === 47081" class="badge">
          {{ 'Not available for US and Canada' | t }}
        </p>
      </div>
    </a>
  </li>
</template>

<script>
import t from '../../main/i18n';

export default {
  props: {
    product: {type: Object, required: true}
  },
  filters: {
    t
  }
};
</script>

<style scoped lang="scss">
@import '../../../scss/system';

$finish-chrome: #f2f4f6;
$finish-nickel: #e2ded4;
$finish-brass: #efdaa3;
$finish-stainless: #dadcde;
$finish-graphite: #5f5f5f;
$finish-black: #323232;
$finish-white: #f8f8f8;

.featured-list {
  max-width: 465px;
}

.swatch {
  width: 16px;
  height: 16px;
  border-radius: 8px;

  &[data-finish='Polished Chrome'] {
    background: $finish-chrome;

    &::after {
      border: 1px solid $color-gray-300;
    }
  }

  &[data-finish='Brushed Nickel'] {
    background: $finish-nickel;
  }

  &[data-finish='Brushed Stainless'] {
    background: $finish-stainless;
  }

  &[data-finish='Polished Brass'] {
    background: $finish-brass;
  }

  &[data-finish='Graphite'] {
    background: $finish-graphite;
    color: $color-white;
  }

  &[data-finish='Matte Black'] {
    background: $finish-black;
    color: $color-white;
  }

  &[data-finish='Matte White'] {
    background: $finish-white;

    &::after {
      border: 1px solid $color-gray-300;
    }
  }

  &[data-finish='Polished White'],
  &[data-finish='White'] {
    background: $color-white;

    &::after {
      border: 1px solid $color-gray-300;
    }
  }
}

.badge {
  margin-top: 10px;
  padding: 3px 7px;
  border: 1px solid #d3d5d6; // not part of the existing color variables
  border-radius: 3px;
  font-size: 14px;
  color: #7c8085; // not part of the existing color variables
  pointer-events: none;
}
</style>
